"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
define('rs/form/abstract.form.entity',['vertebrae', 'rs/form/formobjects/base.formobject.view', 'evisions/dpobject', 'underscore', 'e3-modal'], function (Vertebrae, BaseFormObjectView, DPMixin, _, E3Modal) {
  var _Vertebrae$Controller;
  var BaseFormObject = Vertebrae.Controller.extend((_Vertebrae$Controller = {
    properties: ['children', 'dependencies', 'depthIndex', 'displayed', 'id', 'name', 'label', 'links', 'parent', 'required', 'text', 'description', 'absoluteValid', 'type', 'valid', 'value', 'validCounter', 'helpText', 'compoundType'],
    displayed: true,
    required: false,
    absoluteValid: false,
    validCounter: 0,
    isAnswerable: false,
    propertiesDefinitions: ['id', 'name', 'label', 'text', 'description', 'helpText'],
    linksDefinitions: [],
    events: {
      'view:ready': null
    },
    initialize: function initialize(formObject, parent) {
      if (formObject.dataId) {
        formObject.id = formObject.dataId;
        formObject.dataId = undefined;
      }
      this.disabledMap = {};
      this.disabledMapUnlockValue = {};
      this._super();
      this.setParent(parent);
      this.applyProperties(formObject);
      if (!this.getName()) {
        this.setName(this.getFormController().generateFormObjectName(this.constructor.getTypeString()));
      }
      this._dependentMap = {};
      this.setChildren(this.getFormController().initializeFormObjectsArray(this.getChildren(), this));
      if (this.isDesignerMode() && _.isFunction(this.onTemplateSaveHandler)) {
        this.getFormController().addSaveHandler(this.onTemplateSaveHandler.proxy(this));
      } else if (_.isFunction(this.onAnswerSaveHandler)) {
        this.getFormController().addSaveHandler(this.onAnswerSaveHandler.proxy(this));
      }
      if (!this.isDesignerMode()) {
        this.listenTo(this, 'change:valid', this.triggerListeners);
        this.listenTo(this, 'change:displayed', this.triggerListeners);
        this.listenTo(this, 'change:required', this.triggerListeners);
        this.listenTo(this.getParent(), 'change:displayed', function () {
          this.trigger("change:displayed");
          this.checkAbsoluteValid();
        });
      }
    },
    triggerListeners: function triggerListeners() {
      this.trigger('supremeValidity');
      this.checkAbsoluteValid();
    },
    setName: function setName(value) {
      if (_.isString(value)) {
        value = value.replace(/\W/g, '');
        if (value.length) {
          this.set('name', value);
        }
      }
    },
    checkAbsoluteValid: function checkAbsoluteValid() {
      this.setAbsoluteValid(this.getValid() && this.isVisible());
    },
    requiredIsLinked: function requiredIsLinked() {
      var deps = this.getDependencies();
      return _.chain(deps).pluck('type').filter(function (f) {
        return f == "required";
      }).value().length;
    },
    canAddChildType: function canAddChildType(type) {
      var compoundType = this.getCompoundType();
      if (compoundType && compoundType != type) {
        return false;
      }
      return true;
    },
    canAddChildFormObject: function canAddChildFormObject(fo) {
      if (this === fo) {
        return false;
      } else if (fo && $.contains(fo.getView().el, this.getView().el)) {
        return false;
      } else if (this.getDepthIndex() >= 7) {
        return false;
      }
      return true;
    },
    canLinkToFormObjectByType: function canLinkToFormObjectByType(type, fo) {
      if (type == 'attach' && this.getDependentsByProperty(type).length) {
        return false;
      } else if (this === fo) {
        return false;
      } else if ($.contains(fo.getView().el, this.getView().el)) {
        return false;
      } else if (this.hasDependent(type, fo)) {
        return false;
      } else if (!fo.canBeLinkedFromFormObject(this, type)) {
        return false;
      }
      return true;
    },
    canBeLinkedFromFormObject: function canBeLinkedFromFormObject(linker, type) {
      if (type == "attach") return false;
      return true;
    },
    canHaveLinks: function canHaveLinks() {
      return this.linksDefinitions.length;
    },
    addNewDependent: function addNewDependent(property, formObject) {
      if (!this.hasDependent(property, formObject)) {
        formObject.dependencies.push({
          target: this,
          type: property
        });
        formObject.refreshLocks();
        this.addDependentByProperty(property, formObject);
        this.getFormController().trackFormEvent('Linked form objects', {
          source: this.type,
          target: formObject.type,
          type: property
        });
        this.trigger('change');
      }
    },
    hasDependent: function hasDependent(property, formObject) {
      var dependents = this.getDependentsByProperty(property);
      return _.indexOf(dependents, formObject) > -1;
    },
    removeDependent: function removeDependent(property, formObject) {
      var dependencies = formObject.dependencies,
        dependents = this.getDependentsByProperty(property),
        that = this,
        index = 0;
      formObject.dependencies = _.reject(dependencies, function (d) {
        return d.target == that && d.type == property;
      });
      formObject.refreshLocks();
      index = _.indexOf(dependents, formObject);
      if (index > -1) {
        dependents.splice(index, 1);
      }
      this.trigger('change');
    },
    removeDependency: function removeDependency(formObject) {},
    addDependentByProperty: function addDependentByProperty(property, formObject) {
      var arr = this._dependentMap[property] || (this._dependentMap[property] = []);
      arr.push(formObject);
    },
    getCompareValue: function getCompareValue() {
      return this.getValue();
    },
    getDependentsByProperty: function getDependentsByProperty(property) {
      return this._dependentMap[property] || [];
    },
    getDependentProperties: function getDependentProperties() {
      return _.map(this._dependentMap, function (val, key) {
        return key;
      });
    },
    isRequired: function isRequired() {
      return false;
    },
    isVisible: function isVisible() {
      return true;
    },
    isRequiredGroup: function isRequiredGroup() {
      return this.getType() == "question" && this.getRequired();
    },
    loadData: function loadData() {
      var data = this.getFormController().getFormObjectDataByID(this.getId());
      this.setValue(data, {
        silent: true
      });
    },
    loadAssignmentsToBuilder: function loadAssignmentsToBuilder() {},
    getSectionController: function getSectionController() {
      return this.getParent().getSectionController();
    },
    setupFormObject: function setupFormObject() {
      var i = 0,
        children = this.getChildren(),
        len = null,
        dependencies = null;
      this.setDependencies(this.getFormController().initializeDependencyArray(this.getDependencies(), this));
      dependencies = this.getDependencies();
      for (i = 0, len = children.length; i < len; ++i) {
        children[i].setupFormObject();
      }
      this.refreshLocks();
    },
    refreshLocks: function refreshLocks() {
      if (this.requiredIsLinked()) {
        this.lockProperty('required');
      } else {
        this.unlockProperty('required');
      }
    },
    startListeners: function startListeners() {
      if (this.isDesignerMode()) {
        this.sync('disabledMap');
      } else {
        this.sync('displayed');
        this.sync('required');
      }
    },
    setupChildrenViewProperties: function setupChildrenViewProperties() {
      var view = this.getView(),
        i = 0,
        children = this.getChildren(),
        len = children.length;
      for (i = 0; i < len; ++i) {
        children[i].setup(view.createChildElement());
      }
    },
    getFormController: function getFormController() {
      return this.getParent().getFormController();
    },
    isGroup: function isGroup() {
      return this.getType() == "question";
    },
    testSet: function testSet() {
      var templateModel = this.getFormController().getTemplateModel(),
        readOnly = this.getFormController().getReadOnly();
      if (templateModel.getReadOnly() && !templateModel.preview && !readOnly) {
        return this.getFormController().trySetValue(this, this.getValue(), null);
      }
      return Promise.reject().ignore();
    },
    setValue: function setValue(value, ownLockOverride) {
      var sc = this.getSectionController(),
        templateModel = this.getFormController().getTemplateModel();
      if (sc.isExternallyLocked() && this.getFormController().isLoaded() && !ownLockOverride) {
        return;
      }
      if (this.getFormController().isLoaded() && !sc.isOwned() && !ownLockOverride && templateModel.getReadOnly() && !templateModel.preview) {
        this.getFormController().trySetValue(this, this.getValue(), value);
      } else {
        if (this.isBoolean === true) {
          if (value === true || value === 'true') {
            this.set('value', true);
          } else if (value === false || value === 'false') {
            this.set('value', false);
          } else {
            this.set('value', value);
          }
        } else {
          this.set('value', value);
        }
      }
    }
  }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_Vertebrae$Controller, "isVisible", function isVisible() {
    return this.getDisplayed() && this.getParent().isVisible();
  }), "isValid", function isValid() {
    return !!this.getValid();
  }), "displayedDidChange", function displayedDidChange() {}), "requiredDidChange", function requiredDidChange() {}), "addFormObjectToChildren", function addFormObjectToChildren(inst, index) {
    var children = this.getChildren(),
      view = this.getView();
    inst.getView().$el = view.createChildElement(true);
    this.addChild(inst, index);
    inst.setup(inst.getView().$el);
  }), "updateChildrenRowIndices", function updateChildrenRowIndices() {
    var children = this.getChildren(),
      i = 0,
      len = children.length,
      depth = this.getDepthIndex();
    for (i = 0; i < len; ++i) {
      children[i].setDepthIndex(depth + 1);
      children[i].setRowIndex(i);
      children[i].updateChildrenRowIndices();
    }
  }), "updateChildrenDepthIndices", function updateChildrenDepthIndices() {
    var children = this.getChildren(),
      i = 0,
      len = children.length,
      depth = this.getDepthIndex();
    for (i = 0; i < len; ++i) {
      children[i].setDepthIndex(depth + 1);
      children[i].updateChildrenDepthIndices();
    }
  }), "removeChild", function removeChild(child) {
    var children = this.getChildren();
    index = _.indexOf(this.getChildren(), child);
    children.splice(index, 1);
    child.getView().detach();
    this.updateChildrenRowIndices();
  }), "addChild", function addChild(child, index) {
    var children = this.getChildren(),
      childElement = child.getView().$el;
    child.setParent(this);
    this.getView().insertElementAtIndex(childElement, index);
    children.splice(index, 0, child);
    this.updateChildrenRowIndices();
    child.setDepthIndex(this.getDepthIndex() + 1);
    child.updateChildrenDepthIndices();
    this.getFormController().formObjectDidChange();
  }), "requestInsertAtEnd", function requestInsertAtEnd(entity) {
    this.requestInsertAtIndex(entity, this.getChildren().length);
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_Vertebrae$Controller, "removeFromParent", function removeFromParent() {
    this.getParent().removeChild(this);
  }), "requestDelete", function requestDelete(force) {
    var that = this;
    var actuallyDelete = function actuallyDelete() {
      var children = that.getChildren(),
        dependencies = that.getDependencies(),
        dependentProperties = that.getDependentProperties(),
        dependents = null,
        len = dependencies ? dependencies.length : 0,
        i = 0;
      len = dependencies.length;
      while (len > 0) {
        dependencies[0].target.removeDependent(dependencies[0].type, that);
        dependencies = that.getDependencies();
        len = dependencies.length;
      }
      len = dependentProperties.length;
      that.unload();
      for (i = 0; i < len; ++i) {
        dependents = that.getDependentsByProperty(dependentProperties[i]);
        while (dependents.length > 0) {
          that.removeDependent(dependentProperties[i], dependents[0]);
        }
      }
      len = children ? children.length : 0;
      while (len > 0) {
        children[0].requestDelete(true);
        len = children.length;
      }
      that.removeFromParent();
      that.getFormController().formObjectWasDeleted(that);
    };
    if (force) {
      actuallyDelete();
    } else {
      E3Modal.BtnMsgModal.show({
        title: 'Warning',
        message: 'Are you sure you want to delete this?',
        buttons: ['No', {
          text: 'Yes',
          color: 'danger'
        }]
      }).then(function (btn) {
        if (btn == 'Yes') {
          actuallyDelete();
        }
      });
    }
  }), "requestInsertAtIndex", function requestInsertAtIndex(entity, index) {
    if (entity.getParent() == this && index > entity.getRowIndex()) {
      index--;
    }
    entity.removeFromParent();
    this.addChild(entity, index);
    entity.getView().createSpacer();
  }), "lockProperty", function lockProperty(name, value) {
    if (!this.disabledMap[name]) {
      this.disabledMap[name] = true;
      if (arguments.length > 1) {
        this.disabledMapUnlockValue[name] = this.get(name);
        this.set(name, value);
      }
      this.trigger('change:disabledMap');
    }
  }), "unlockProperty", function unlockProperty(name) {
    if (this.disabledMap[name]) {
      this.disabledMap[name] = null;
      if (this.disabledMapUnlockValue[name] !== undefined) {
        this.set(name, this.disabledMapUnlockValue[name]);
        delete this.disabledMapUnlockValue[name];
      }
      this.trigger('change:disabledMap');
    }
  }), "isPropertyLocked", function isPropertyLocked(name) {
    return !!this.disabledMap[name];
  }), "refreshDisabledMapPropertyOnView", function refreshDisabledMapPropertyOnView() {
    var formController = this.getFormController(),
      control = formController.getFormObjectForPropertiesUpdate();
    if (control === this) {
      this.getFormController().triggerRefreshPropertiesTab();
    }
  }), "getPropertiesDefinitions", function getPropertiesDefinitions() {
    var that = this,
      propDfn = null,
      reqDisabled = this.requiredIsLinked();
    return _.map(this.propertiesDefinitions, function (m) {
      propDfn = _.extend({}, that.constructor.propertiesDefinitions[m]);
      propDfn.value = that.get(propDfn.name);
      if (propDfn.dropdown) {
        propDfn.valuesGetter = propDfn.values;
        propDfn.values = that[propDfn.values] ? that[propDfn.values](propDfn.value) : propDfn.values;
        propDfn.selectedIndex = that[propDfn.selectIndex] ? that[propDfn.selectIndex](propDfn.value, propDfn.values) : _.indexOf(propDfn.values, function (v) {
          return propDfn.value == v;
        });
        propDfn.values = _.map(propDfn.values, function (v) {
          return {
            value: propDfn.displayKey ? v[propDfn.displayKey] : v
          };
        });
        if (propDfn.selectedIndex > -1 && propDfn.values[propDfn.selectedIndex]) {
          propDfn.values[propDfn.selectedIndex].selected = true;
        }
      }
      if (that.isPropertyLocked(propDfn.name)) {
        propDfn.disabled = true;
      } else {
        propDfn.disabled = false;
      }
      return propDfn;
    });
  }), "getLinksDefinitions", function getLinksDefinitions() {
    var that = this,
      linkDfn = null;
    return _.map(this.linksDefinitions, function (m) {
      linkDfn = that.constructor.propertiesDefinitions[m];
      linkDfn.targets = that.getDependentsByProperty(linkDfn.type);
      return linkDfn;
    });
  }), "removeItemFromPropertyList", function removeItemFromPropertyList(propertyName, index) {
    var listItems = this.get(propertyName);
    listItems.splice(index, 1);
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_Vertebrae$Controller, "isCompoundChild", function isCompoundChild() {
    return false;
  }), "isDesignerMode", function isDesignerMode() {
    return this.getFormController().isDesignerMode();
  }), "selectText", function selectText() {}), "selectLabel", function selectLabel() {}), "toJSON", function toJSON() {
    var children = this.getChildren(),
      jsonChildren = [],
      properties = this.getDependentProperties(),
      dependencies = [],
      len = children ? children.length : 0,
      i = 0;
    for (i = 0; i < len; ++i) {
      jsonChildren.push(children[i].toJSON());
    }
    if (this.getDependencies().length) {
      dependencies = _.map(this.getDependencies(), function (dep) {
        return {
          type: dep.type,
          targetId: dep.target.getId()
        };
      });
    }
    return {
      dataId: this.getId(),
      name: this.getName(),
      type: this.getType() || 'question',
      label: this.getLabel(),
      text: this.getText(),
      description: this.getDescription(),
      children: jsonChildren.length ? jsonChildren : undefined,
      dependencies: dependencies.length ? dependencies : undefined
    };
  })), {
    getTypeString: function getTypeString() {
      return 'Abstract';
    },
    propertiesDefinitions: {
      'id': {
        name: 'id',
        label: true,
        displayName: 'ID'
      },
      'name': {
        name: 'name',
        noLiveUpdate: true,
        text: true,
        displayName: 'Name',
        maxLength: 100
      },
      'label': {
        name: 'label',
        text: true,
        displayName: 'Label',
        maxLength: 10
      },
      'text': {
        name: 'text',
        text: true,
        richtext: true,
        displayName: 'Title'
      },
      'description': {
        name: 'description',
        text: true,
        richtext: true,
        displayName: 'Description'
      },
      'helpText': {
        name: 'helpText',
        text: true,
        richtext: true,
        displayName: 'Help Text'
      },
      'required': {
        name: 'required',
        bool: true,
        displayName: 'Required'
      },
      'link.displayed': {
        type: 'displayed',
        displayName: 'Displays'
      },
      'link.required': {
        type: 'required',
        displayName: 'Requires'
      }
    }
  });
  DPMixin.setup(BaseFormObject.prototype);
  return BaseFormObject;
});

